import { Mood } from '@intigral/shared';
import { __ } from '../../../../translations';

export const getListing = (content, onClickHandler) => {
    if (!content || content.length === 0) {
        return [];
    }

    return content.map(({ id, title, image }) => (
        <Mood key={id} id={id} title={__(title)} image={image} onClickHandler={onClickHandler} />
    ));
};

export const getLoader = (cards = 4) => {
    return Array.from({ length: cards }, (_, i) => <Mood isLoading key={`mood_loader_${i}`} />);
};
